import PropTypes from 'prop-types'
import React, { Fragment, useState, useRef } from 'react'

import PropTypesHelpers from '../../utils/propTypesHelpers'

import CityListItem from './CityListItem'

export const CityList = (
  {
    queryKey = 'pl',
    items,
    itemProps,
    tag: Tag = 'span',
    unique = true,
    parentContainer,
    hideOverflow = false,
    ...props
  }
) => {
  const [citiesRefs, setCitiesRefs] = useState([])

  const parentDom = parentContainer ? parentContainer.current : null

  const observerRef = useRef(null)

  if (unique) {
    items = [...new Set(items)]
  }

  if (parentContainer && parentContainer.current && hideOverflow && !observerRef.current) {
    observerRef.current = new window.IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style = ''
        } else {
          entry.target.style = 'color: transparent !important; user-select: none;'
        }
      })
    }, {
      threshold: 1,
      root: parentDom,
      rootMargin: '0px 0px -16px 0px'
    })

    citiesRefs.forEach((cityRef) => observerRef.current.observe(cityRef))
  }

  const { current: observer } = observerRef

  return (
    <>
      {Boolean(items?.length) && (
        <Tag {...props} className='city-list'>
          {items.map((item, idx) => {
            return (
              <Fragment key={unique ? item : idx}>
                <CityListItem
                  {...itemProps}
                  label={item}
                  query={{ [queryKey]: item }}
                  ref={(dom) => {
                    if (dom && hideOverflow && citiesRefs.indexOf(dom) < 0) {
                      if (observer) {
                        observer.observe(dom)
                      } else {
                        setCitiesRefs([...citiesRefs, dom])
                        dom.style = 'color: transparent !important; user-select: none;'
                      }
                    }
                  }}
                />
              </Fragment>
            )
          })}
        </Tag>
      )}
    </>
  )
}

CityList.propTypes = {
  queryKey: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  itemProps: PropTypes.object,
  tag: PropTypesHelpers.tag,
  unique: PropTypes.bool,
  parentContainer: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]),
  hideOverflow: PropTypes.bool
}

export default CityList
